import * as React from "react";
import PositionTopSecContent from "../generic/positionTopSecContent";
import DeviceContext from "../../../service/indentifyDevice";
import PositionTblContent from "../positionTable/positionTblContent";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/position/positionLayout/positionLayoutDsk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../assets/scss/components/toc/position/positionLayout/positionLayoutMob.scss");
} else {
	require("../../../../assets/scss/components/toc/position/positionLayout/positionLayoutTab.scss");
}

export interface IPositionLayoutProps {
	data: any;
}

const PositionLayout: React.FC<IPositionLayoutProps> = (props) => {
	const [isFixed, setIsFixed] = React.useState<boolean>(false);
	const [hideTopSection, setHideTopSection] = React.useState(false);

	//top section content
	const [ttPos, setTTPos] = React.useState<{ totalMtm: string; totalrealizedMtm: string; totalunrealizedMtm: string }>({
		totalrealizedMtm: props.data ? props.data.tdyMtm : "0",
		totalMtm: props.data ? (+props.data.tdyMtm + +props.data.urlMtm).toString() : "0",
		totalunrealizedMtm: props.data ? props.data.urlMtm : "0"
	});
	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		(e.target as HTMLElement).scrollTop > 90 ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);
	}
	function updateUnMTM(unMTM: string) {
		setTTPos({ ...ttPos, totalunrealizedMtm: unMTM, totalMtm: (+props.data.tdyMtm + +unMTM).toString() });
	}

	return (
		<section className={"position_wrapper" + (isFixed ? " pos_scroll_active" : "")}>
			<section className="position_container">
				<section className="list_view">
					<div className={"pos_header" + (hideTopSection ? " hide_top_section" : "")}>
						<PositionTopSecContent {...ttPos} />
					</div>
					<div className="pos_content">
						<div className="pos_list" onScroll={onContainerScroll}>
							<PositionTblContent data={props.data} hideTopSection={setHideTopSection} updateUnMTM={updateUnMTM} />
						</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default PositionLayout;
